import React, { useState, useMemo } from 'react';
import styles from './styles.module.css';
import { Box, Flex, Stack, StackSeparator, Text } from '@chakra-ui/react';
import { CheckboxIcon } from '@/_assets/icon-components';

interface IProps {
  results: any[];
  searchValue: string;
  onSelect: (e: any, type: string) => void;
}

export default function AddressDropdown({
  results = [],
  searchValue,
  onSelect,
}: IProps) {
  // Find matching item based on searchValue
  const matchedIndex = useMemo(() => {
    if (!searchValue || !results?.length) return null;
    const normalizedSearch = searchValue.trim().toLowerCase();
    const index = results.findIndex(
      (item) =>
        item?.label?.toLowerCase() === normalizedSearch ||
        item?.label?.toLowerCase().includes(normalizedSearch)
    );
    return index !== -1 ? index : null;
  }, [searchValue, results]);

  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);

  // Use selectedIndex if manually selected, otherwise use matchedIndex
  const activeIndex = selectedIndex ?? matchedIndex;

  const handleSelect = (item: any, index: number) => {
    setSelectedIndex(index);
    onSelect(item, 'suggest');
  };

  return (
    <Stack
      p={2}
      left={0}
      w='full'
      maxH={363}
      zIndex={1503} // over zone info
      overflowY='auto'
      borderRadius='lg'
      position='absolute'
      bg='background.card'
      top='calc(100% + 4px)'
      separator={<StackSeparator />}
      boxShadow='0px 4px 6px 0px #00000033, 0px 4px 6px 0px #0000000A'
    >
      {results?.map(
        (item, index) =>
          item?.label && (
            <Option
              data={item}
              isSelected={activeIndex === index}
              onSelect={() => handleSelect(item, index)}
              key={item?.distance + item?.description + item?.label + 'suggest'}
            />
          )
      )}
    </Stack>
  );
}

interface IOptionProps {
  data: { label: string; description: string; distance: string };
  isSelected: boolean;
  onSelect: (data: any) => void;
}

const Option = ({ data, isSelected, onSelect }: IOptionProps) => {
  return (
    <Flex
      align='center'
      justify='space-between'
      _hover={{
        bg: 'light.200',
      }}
      className={styles.search_address_option}
      onClick={() => onSelect(data)}
      px={4}
      py={'14px'}
    >
      <Box flex={1}>
        <Text mb={0.5} fontWeight={500} color='text'>
          {data?.label}
        </Text>
        {/* <Text fontSize='small' color='text.muted' lineHeight={1.2}>
          {data?.description}
        </Text> */}
      </Box>
      <Box ml={3} flexShrink={0}>
        {isSelected ? (
          <CheckboxIcon color='var(--primary-default)' size={24} />
        ) : (
          <Box w={6} h={6} rounded='full' bg='gray.400' border='none' />
        )}
      </Box>
    </Flex>
  );
};
